module.exports = __webpack_public_path__ + "img/adhesivo_para_pisos_y_muros_de_interiores.ed83c8c3.png";